


























import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import UiList from '@superUI/List/List'

settings =
  name: 'OfferList'
  components: { SuperContainerView, UiList }
  resources:
    brand_opportunities:
      resourceName: 'brand_opportunities'
      slug: 'brand_opportunities'
      infinityScroll: true

  vue:
    data: ->
      searchValue: ''
      searchTimeout: null

    methods:
      hiFilterChange: ->
        @fetchInfinity(null, 'brand_opportunities', @combinedFilters(), { page: 1 })

      combinedFilters: ->
        q = @searchValue
        return { q }

    watch:
      searchValue: (value) ->
        ctx = this
        window.stop()
        clearTimeout(@searchTimeout)
        @searchTimeout = setTimeout(() ->
          ctx.hiFilterChange()
        , 500)

export default VueOptions.vue settings
